import type { NamespaceSchema } from './types';

// Driver dispatch knobs — how an assigned job is offered to individual
// drivers in waves. Read by apps/api core/dispatch/settings.ts.
//
// DISTINCT FROM bid-settings, which governs CREW PRICE-BIDDING: a company
// competing to quote a booking. This governs offering an already-priced job to
// a person. The Schema Delta says wave size/timeout/radius "already live in
// bid-settings.dispatchMode" — they do not; that field is admin|broadcast and
// carries no dispatch geometry at all. Overloading it would have coupled two
// unrelated mechanisms.

export const dispatchSettings: NamespaceSchema = {
  namespace: 'dispatch-settings',
  label: 'Driver dispatch',
  description:
    'How an assigned job is offered to drivers. Offers go out in waves: the first wave reaches the nearest drivers, and each later wave widens the search. A driver who declines is not offered the same job again.',
  sections: [
    {
      label: 'Waves',
      fields: [
        {
          kind: 'number',
          key: 'waveSize',
          label: 'Drivers offered per wave',
          default: 3,
          min: 1,
          step: 1,
        },
        {
          kind: 'number',
          key: 'waveTimeoutSeconds',
          label: 'Seconds a driver has to accept',
          default: 30,
          min: 10,
          step: 5,
        },
        {
          kind: 'number',
          key: 'maxWaves',
          label: 'Waves before giving up',
          default: 4,
          min: 1,
          step: 1,
        },
      ],
    },
    {
      label: 'Search area',
      fields: [
        {
          kind: 'number',
          key: 'initialRadiusKm',
          label: 'First wave radius (km)',
          default: 3,
          min: 1,
          step: 1,
        },
        {
          kind: 'number',
          key: 'radiusStepKm',
          label: 'Widen by (km) each wave',
          default: 3,
          min: 0,
          step: 1,
        },
        {
          kind: 'number',
          key: 'driverStaleSeconds',
          label: 'Ignore drivers not seen for (seconds)',
          default: 120,
          min: 30,
          step: 30,
        },
      ],
    },
  ],
};
